import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useClient } from "../../ClientContext";
import { PortalClientError } from "../../types";
import { JsonApiResponse } from "../types";
import { Application } from "./types";

const useApplications = <TData extends {} = JsonApiResponse<Application[]>>(
  options?: UseQueryOptions<
    JsonApiResponse<Application[]>,
    PortalClientError,
    TData
  >
) => {
  const client = useClient();

  return useQuery<JsonApiResponse<Application[]>, PortalClientError, TData>(
    ["applications"],
    () => client.get("/applications"),
    {
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};

export default useApplications;
